<template>
  <v-card v-if="model.id" class="elevation-2">
    <v-card-title class="text-h5">
      <h2 class="font-weight-bold text--primary">Colaboradores</h2>
    </v-card-title>
    <v-card-subtitle></v-card-subtitle>
    <v-card-text>
      <v-row dense>
          <v-col cols="12">
            <DataTableMain :datatable="tableEmpleados" :on-success="successAction" :itemsAction="tableAction"/>
          </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import DataTableMain from '@/components/tables/DataTableMain'
export default {
  props: ['model', 'onSuccess'],
  data: () => ({
    tableEmpleados: {
      header: {
        options: [],
        titles: [
          { text: 'Cve Empleado', value: 'adscripcion.empleado.cve_empleado', class: 'black--text' },
          { text: 'Nombre Completo', value: 'adscripcion.empleado.NombreCompleto', class: 'black--text' },
          { text: 'Puesto', value: 'adscripcion.plaza.puesto.nombre', class: 'black--text' },
          { text: 'Categorria', value: 'adscripcion.plaza.categoria.nombre', class: 'black--text' },
          { text: 'Plaza', value: 'adscripcion.plaza.nombre', class: 'black--text' },
          { text: 'Bruto', value: 'FieldDinamicDataSimple', class: 'black--text', action: 'FormatNumberMoney', field: 'Bruto' },
          { text: 'ISPT', value: 'FieldDinamicDataSimple', class: 'black--text', action: 'FormatNumberMoney', field: 'total_impuestos_retenidos' },
          { text: 'Subsidio', value: 'FieldDinamicDataSimple', class: 'black--text', action: 'FormatNumberMoney', field: 'total_otros_pagos' },
          { text: 'Neto', value: 'FieldDinamicDataSimple', class: 'black--text', action: 'FormatNumberMoney', field: 'Neto' },
          { text: '', value: 'ActionsLocal', class: 'black--text' }
        ],
        loading: false
      },
      body: {
        data: [],
        actions: [
          { title: 'Ver Detalles', icon: 'mdi-eye', color: 'primary darken-1', action: 'viewData', code: 'libre', hidden: '' },
          { title: 'Recibo Nomina', icon: 'mdi-file-pdf-box', color: 'yellow darken-3', action: 'ExportRecibo', code: 'libre', hidden: '' },
          { title: 'Dispersion Nomina', icon: 'mdi-zip-box', color: 'yellow darken-3', action: 'ExportDispersion', code: 'libre', hidden: '' }
        ]
      },
      footer: {
        paging: true
      }
    }
  }),
  components: {
    DataTableMain
  },
  methods: {
    ...mapActions(['getUrExporPdftDataServerAction', 'getUrExportZipDataServerAction']),
    ...mapMutations([]),
    // Methods Table \\
    successAction (item) {
      this[item.action](item)
    },
    // *-----*------*-----*------*-----*------*-----*------* \\
    tableAction (item) {
      this[item.action](item)
    },
    viewData (item) {
      this.onSuccess({ action: 'nominaDetailEmployee', item: item.item })
    },
    ExportRecibo (item) {
      const url = this.get_urls['GET/nomina/reportes/recibos/{nomina_id}[/{adscripcion_id}]']
      this.getUrExporPdftDataServerAction({ url: url, params: `/${item.item.padre_id}/${item.item.adscripcion_id}`, replace: '/{nomina_id}[/{adscripcion_id}]', nombre: item.item.folio })
    },
    ExportDispersion (item) {
      const url = this.get_urls['GET/nomina/dispersiones/hsbc/{nomina_id}[/{adscripcion_id}]']
      this.getUrExportZipDataServerAction({ url: url, params: `/${item.item.padre_id}/${item.item.adscripcion_id}`, replace: '/{nomina_id}[/{adscripcion_id}]', nombre: item.item.folio })
    }
    // END Methods Table END \\
  },
  computed: {
    ...mapGetters(['get_urls'])
  },
  watch: {
    model (val) {
      if (val) {
        this.tableEmpleados.body.data = val.nominas
      }
    }

  }
}
</script>

<style></style>
